import { AdminApiRoutes } from '@gr/core/admin-api-routes';
import { ApiRoutes } from '@gr/core/api-routes';
import type { BackupDto, BackupUploadDto } from '@gr/core/platform/operations/backups';
import type { SystemInfoDto } from '@gr/core/platform/operations/dto';
import type { TaskDto } from '@gr/core/platform/tasks/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient, UploadProgress } from '../../../shared/http/http-client';

export class OperationsApi {
  constructor(private readonly http: HttpClient) {}

  // DEMO-UC-1, OPS-UC-3: сведения о режиме работы сервера. Маршрут отдаёт DTO без обёртки —
  // HttpClient заворачивает его в OperationResult.
  info(): Promise<OperationResult<SystemInfoDto>> {
    return this.http.get(ApiRoutes.operations.info);
  }

  // OPS-UC-9
  backups(): Promise<OperationResult<BackupDto[]>> {
    return this.http.get(AdminApiRoutes.backups.list);
  }

  // OPS-UC-8
  createBackup(): Promise<OperationResult<TaskDto>> {
    return this.http.post(AdminApiRoutes.backups.list, {});
  }

  // OPS-UC-10: файл уходит «сырым» телом с прогрессом.
  uploadBackup(file: File, onProgress?: (progress: UploadProgress) => void): Promise<OperationResult<BackupUploadDto>> {
    return this.http.upload(AdminApiRoutes.backups.upload, file, onProgress);
  }

  /** OPS-UC-9: скачивание — обычной ссылкой, с сессией в куки. */
  downloadUrl(name: string): string {
    return AdminApiRoutes.backups.download(encodeURIComponent(name));
  }

  // OPS-UC-9
  deleteBackup(name: string): Promise<OperationResult<null>> {
    return this.http.delete(AdminApiRoutes.backups.byName(encodeURIComponent(name)));
  }

  // OPS-UC-11
  restoreBackup(name: string): Promise<OperationResult<TaskDto>> {
    return this.http.post(AdminApiRoutes.backups.restore(encodeURIComponent(name)), {});
  }
}
